import React from "react";

import { RouteFactory } from "./route-factory";

// Layouts base
import {
  BaseLayout,
  LoginDeveloperLayout,
  RegisterDeveloperLayout,
  LoginAdminLayout,
  DefaultLayout,
} from "../layouts";

// Register Pages
import {
  MakeRegisterDeveloperWithoutCompany,
  MakeRegisterDeveloperCompany,
  MakePlan,
  MakeContract,
  MakeAnalizing,
  MakeRegister,
  MakeConfirmRegister,
  MakeChooseRegisterType,
} from "../../../main/factories/pages/register/pages";

// Admin Pages
import {
  MakeSolicitationEdit,
  MakeSolicitationNew,
  MakeCompanyEdit,
  MakeAdminLogin,
  MakeAdminForgotPassword,
  MakeAdminRecoveryPassword,
} from "../../../main/factories/pages/admin";

// Developer Pages
import {
  MakeHomeDeveloper,
  MakeSignIn,
  MakeDevForgotPassword,
  MakeDevRecoveryPassword,
  MakeDevNewPassword,
  MakeIntro,
} from "../../../main/factories/pages/developer";

// Pages
import PageNotFound from "../../pages/register-account/page-not-found";
import ConfirmationEmail from "../../pages/register-account/confirmation-email";
import MenuNfInvoice from "../../pages/nf-invoice/menu";
import AdminBaseLayout from "../layouts/admin-base-layout";
import MakeComapaniesList from "../../../main/factories/pages/admin/companies/list";
import MakeSolicitationList from "../../../main/factories/pages/admin/solicitations/list";
import MakeCustomerForm from "../../../main/factories/pages/admin/customer/form";
import MakeHomeAdmin from "../../../main/factories/pages/admin/home";
import MakeIssue from "../../../main/factories/pages/developer/issue";
import MakeDocumentsList from "../../../main/factories/pages/developer/documents/list";
import ExitPage from "../../pages/register-account/exit";
import MakeDocumentsDeveloper from "../../../main/factories/pages/admin/companies/list/documents/list";
import MakeInvoice from "../../../main/factories/pages/developer/invoice";
import LinkedInPage from "../../../main/factories/pages/developer/linkedin";
import TermsUse from "../../pages/register-account/contract/terms-use";

const MakeProfile = React.lazy(
  () => import("../../../main/factories/pages/developer/profile"),
);

function Routes(): JSX.Element {
  const routes = [
    {
      layout: DefaultLayout,
      pages: [
        { path: "/registrar", component: MakeRegister },
        {
          path: "/confirmacao-de-email",
          component: ConfirmationEmail,
        },
        {
          path: "/register-account/:code/:email",
          component: MakeConfirmRegister,
        },
        { path: "/termos-de-uso", component: TermsUse },
      ],
    },
    {
      layout: AdminBaseLayout,
      pages: [
        { path: "/admin/home", component: MakeHomeAdmin, exact: true },
        {
          path: "/admin/developers",
          component: MakeComapaniesList,
          exact: true,
        },
        {
          path: "/admin/developers/documents/:id",
          component: MakeDocumentsDeveloper,
          exact: true,
        },
        {
          path: "/admin/solicitations",
          component: MakeSolicitationList,
          exact: true,
        },
        {
          path: "/admin/customer/:id",
          component: MakeCustomerForm,
          exact: true,
        },
        {
          path: "/admin/developers/edit/:id",
          component: MakeCompanyEdit,
          exact: true,
        },
        {
          path: "/admin/developers/view/:id",
          component: MakeCompanyEdit,
          exact: true,
        },
        {
          path: "/admin/solicitation/edit/:id",
          component: MakeSolicitationEdit,
          exact: true,
        },
        {
          path: "/admin/solicitation/new",
          component: MakeSolicitationNew,
          exact: true,
        },
      ],
    },
    {
      layout: RegisterDeveloperLayout,
      pages: [
        {
          path: "/cadastro-basico/1",
          component: MakeRegisterDeveloperWithoutCompany,
        },
        {
          path: "/cadastro-basico/2",
          component: MakePlan,
        },
        {
          path: "/cadastro-basico/3",
          component: MakeContract,
        },
        {
          path: "/cadastro-basico/4",
          component: MakeAnalizing,
        },
        {
          path: "/cadastrar-empresa/1",
          component: MakeRegisterDeveloperCompany,
        },
        {
          path: "/cadastrar-empresa/2",
          component: MakePlan,
        },
        {
          path: "/cadastrar-empresa/3",
          component: MakeContract,
        },
        {
          path: "/cadastrar-empresa/4",
          component: MakeAnalizing,
        },
        { path: "/cadastro", component: MakeChooseRegisterType },
      ],
    },
    {
      layout: BaseLayout,
      pages: [
        { path: "/home", component: MakeHomeDeveloper },
        { path: "/profile", component: MakeProfile },
        { path: "/invoice", component: MakeInvoice },
        { path: "/issue", component: MakeIssue },
        { path: "/documents", component: MakeDocumentsList },
        { path: "/menu", component: MenuNfInvoice },
        { path: "/exit", component: ExitPage },
      ],
    },
    {
      layout: LoginAdminLayout,
      pages: [
        { path: "/admin", component: MakeAdminLogin },
        { path: "/admin/forgot-password", component: MakeAdminForgotPassword },
        {
          path: "/admin/recovery-password",
          component: MakeAdminRecoveryPassword,
        },
      ],
    },
    {
      layout: LoginDeveloperLayout,
      pages: [
        { path: "/", component: MakeSignIn },
        { path: "/intro", component: MakeIntro },
        {
          path: "/developer/forgot-password",
          component: MakeDevForgotPassword,
        },
        {
          path: "/developer/recovery-password",
          component: MakeDevRecoveryPassword,
        },
        {
          path: "/developer/new-password",
          component: MakeDevNewPassword,
        },
        { path: "/linkedin", component: LinkedInPage, exact: false },
        { path: "*", component: PageNotFound },
      ],
    },
  ];

  return <RouteFactory routes={routes} />;
}

export default Routes;
